export const debugWatchedProps = (watchedProps, bypass) => {
    if(bypass) return watchedProps;

    const regex1 = /::: /g;
    const regex2 = /watchedHhmsProps : /;
    const regex3 = /HOUSEHOLD_MEMBER/g;
    const regex4 = /_PROPS:/g;

    console.log(
        watchedProps
            .replace(regex1,`
            `)
            .replace(regex2, `
            watchedHhmsProps : ====== SEE BELOW ========
            `)
            .replace(regex3, `
            HOUSEHOLD_MEMBER`)
            .replace(regex4, `_PROPS:
            `)
    );

    return watchedProps;
};